import { render, staticRenderFns } from "./pointsCode.vue?vue&type=template&id=7cf2bc8c&scoped=true"
import script from "./pointsCode.vue?vue&type=script&lang=js"
export * from "./pointsCode.vue?vue&type=script&lang=js"
import style0 from "./pointsCode.vue?vue&type=style&index=0&id=7cf2bc8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf2bc8c",
  null
  
)

export default component.exports